export default {
  info: {
    loading: 'Loading...',
    shareDeal: 'Please click the below to share the deal URL.',
    notApplicable: 'N/A',
  },
  success: {
    singleDealDelete: 'Deal successfully deleted.',
    multipleDealsDelete: 'Deal(s) successfully deleted.',
    copiedToClipboard: 'Copied to clipboard.',
    saveDeal: 'Successfully saved deal',
    bookmarkAdded: 'has been saved to My Bookmark',
    bookmarkDeleted: 'has been deleted from My Bookmark',
    bookmarkUpdated: 'has been updated in My Bookmark',
    productReleasesDeleted: 'The update has been deleted and removed from Whats new page.',
    productReleasesUpdated: 'The update has been posted.',
  },
  warnings: {
    httpRequestCanceled: 'HTTP request canceled.',
    dealNotFound: 'No deal found.',
    deleteDealConfirmation: 'Are you sure you want to delete the deal(s)?',
    duplicateDealConfirmation: 'Are you sure you want to duplicate this deal?',
    unsavedChanges: 'You have unsaved changes. Do you want to save your progress?',
    noData: 'No data to display.',
    baseBatnaRequired: 'Base & BATNA formulas are required before adding options.',
    removedProductsFromPareto: 'Removed volume without margin.',
    noBookmarks: 'No bookmarks',
  },
  errors: {
    default: 'There was an error. Please try again later.',
    authorizationUrl:
      'There was an error fetching the authorization url. Please contact a Port administrator or try again later.',
    input: 'Input value is invalid.',
    singleDealDelete: 'There was an error deleting the deal.',
    multipleDealDelete: 'There was an error deleting the deal(s).',
    noMarkers: 'No markers found.',
    noRefreshToken: 'No refresh token found.',
    invalidNumber: 'Must be a positive number.',
  },
};
